import { FormValues, SearchBarProps } from '../../components/SearchBar';

export default function validateForm(
  values: FormValues,
  { intl: { T } }: SearchBarProps,
) {
  const errors: {
    [K in keyof FormValues]?: string | undefined;
  } = {};

  if (!values.place) {
    errors.place = T('home_search_bar_error_place_is_required');
  }

  if (values.place && values.place.length <= 2) {
    errors.place = T('Wrong format');
  }

  return errors;
}
